import { type ReactNode } from 'react';

import { Text } from '@spotify-internal/encore-web';

import styles from './IssueIconLabel.module.css';

export type IssueIconLabelSize = 'small' | 'smaller';

type IssueIconLabelProps = {
  icon: ReactNode;
  label: string;
  size: IssueIconLabelSize;
};

export const IssueIconLabel = ({ icon, label, size }: IssueIconLabelProps) => (
  <span className={styles.root} data-size={size}>
    {icon}
    <Text as="span" variant={size === 'small' ? 'bodySmall' : 'marginal'}>
      {label}
    </Text>
  </span>
);
